/* BROX: <hover-video> — plays a muted product-card video on hover (desktop),
   pauses + resets on leave. preload="none" so nothing loads until first hover,
   which keeps collection/featured pages light and means mobile never downloads
   the videos (there is no hover on touch). */
if (!customElements.get("hover-video")) {
  customElements.define(
    "hover-video",
    class HoverVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector("video");
        if (!this.video) return;
        this.scope =
          this.closest(".m-product-card__media") ||
          this.closest(".m-product-card") ||
          this;
        this._enter = this.playVideo.bind(this);
        this._leave = this.resetVideo.bind(this);
        this.scope.addEventListener("mouseenter", this._enter);
        this.scope.addEventListener("mouseleave", this._leave);
      }

      disconnectedCallback() {
        if (!this.scope) return;
        this.scope.removeEventListener("mouseenter", this._enter);
        this.scope.removeEventListener("mouseleave", this._leave);
      }

      playVideo() {
        if (!this.video) return;
        var p = this.video.play();
        if (p && p.catch) p.catch(function () {});
      }

      resetVideo() {
        if (!this.video) return;
        this.video.pause();
        try {
          this.video.currentTime = 0;
        } catch (e) {}
      }
    }
  );
}